import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const I18N_PREFIX = 'create_career.adjustment.'

/**
 * Abschnitts-Navigation fuer die Einstellungen.
 *
 * Der Schritt war frueher in drei Tabs geteilt, jeder Tabwechsel unmountete
 * den vorherigen. Jetzt stehen die Abschnitte untereinander, und weil das
 * Challenge-Grid den Grossteil der Hoehe ausmacht, waeren Haerte und
 * Muss-Kriterien ohne diese Navigation weit unter dem Fold.
 *
 * Visuell dieselbe Sprache wie die Navigation unter /settings, damit der
 * Schritt keine zweite Formensprache einfuehrt.
 */
const SectionNav = ({ sections, activeId, onSelect }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='xl:hidden'>
        <label htmlFor='adjustment-sections' className='sr-only'>
          {t(I18N_PREFIX + 'select_a_tab')}
        </label>
        <select
          id='adjustment-sections'
          value={activeId}
          onChange={(event) => onSelect(event.target.value)}
          className='block w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500'
        >
          {sections.map(({ id, name }) => (
            <option key={id} value={id}>
              {name}
            </option>
          ))}
        </select>
      </div>

      {/* sticky self-start: die Navigation soll mitlaufen, die Spalte aber
          nicht auf volle Hoehe wachsen. */}
      <nav
        aria-label={t(I18N_PREFIX + 'sections_label')}
        className='sticky top-8 hidden shrink-0 flex-col gap-y-2 self-start xl:flex'
      >
        {sections.map(({ id, name }) => {
          const isActive = activeId === id

          return (
            <div key={id} className='group flex items-center'>
              <div
                aria-hidden='true'
                className={clsx(
                  'mr-1 h-8 w-1 rounded-full',
                  isActive ? 'bg-blue-500' : 'group-hover:bg-gray-500'
                )}
              />
              <button
                type='button'
                onClick={() => onSelect(id)}
                aria-current={isActive ? 'true' : undefined}
                className={clsx(
                  'inline-flex w-64 cursor-pointer items-center rounded-md px-4 py-3 text-left text-sm font-medium',
                  'focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2',
                  isActive
                    ? 'bg-gray-100 text-blue-600'
                    : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                )}
              >
                {name}
              </button>
            </div>
          )
        })}
      </nav>
    </>
  )
}

SectionNav.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })
  ).isRequired,
  activeId: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default SectionNav
